import * as React from 'react';
const styles = require('./RiskRating.pcss');

interface IProps {
    rating : number;
}

export class RiskRating extends React.Component<IProps, {}>{
    render() {
        return (
            <div className={styles.riskRating}>
                <ul>
                    <li>1</li>
                    <li>2</li>
                    <li className={styles.active}>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                </ul>

                <footer>
                    <span className={styles.bounds}>Lower Risk*</span>
                    <span className={styles.bounds}>Higher Risk</span>
                </footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/RiskRating/RiskRating.tsx